module.exports = __webpack_public_path__ + "static/media/wave-privacy-statement.5754db64.pdf";